import React, {useLayoutEffect } from "react"

export async function GenerateBotResponse({ signal, formData, controller }) {
  const API_KEY = "#####";
  const API_URL = `https://titan.opm.com.hk/webhook/chatbot`;
  const timeoutMs = 30000;

  const requestOptions = {
    method: "POST",
    body: formData,
  };

  const timeout = setTimeout(() => {
    try {
      controller?.abort(new DOMException('timeout', 'AbortError'));
    } catch {
      if (controller) controller._abortedBy = 'timeout';
      controller?.abort();
    }
  }, timeoutMs);

  const options = { ...requestOptions, signal };

  try {
    const res = await fetch(API_URL, options);
    clearTimeout(timeout);
    let data = await res.json();
    const apiResponseText = data.output;
    return apiResponseText;
  } catch (err) {
    clearTimeout(timeout);
    if (err.name === 'AbortError') {
      const reason = err.message || controller?._abortedBy;
      if (reason === 'user') return "";
      if (reason === 'timeout') return "Request timed out. Please check your network and try again.";
      return "Request aborted";
    }
    throw err;
  }
}


export function CreateMessageElement({ content, classes = [] }) {
  const className = ["message", ...classes].join(" ")
  const isBot = classes.includes("bot-message")

  return (
    <div className={className}>
      {isBot ? (
        content
      ) : (
        content
      )}
    </div>
  )
}



export function MessageContent({ text }) {
  return (
    <>
      <div className="message-text">{text}</div>
    </>
  )
}


export function BotInitialMessage() {
  return (
    <div class="message bot-message">
      <svg
        class="bot-avatar"
        xmlns="http://www.w3.org/2000/svg"
        width="50"
        height="50"
        viewBox="0 0 1024 1024"
      >
        <path
          d="M738.3 287.6H285.7c-59 0-106.8 47.8-106.8 106.8v303.1c0 59 47.8 106.8 106.8 106.8h81.5v111.1c0 .7.8 1.1 1.4.7l166.9-110.6 41.8-.8h117.4l43.6-.4c59 0 106.8-47.8 106.8-106.8V394.5c0-59-47.8-106.9-106.8-106.9zM351.7 448.2c0-29.5 23.9-53.5 53.5-53.5s53.5 23.9 53.5 53.5-23.9 53.5-53.5 53.5-53.5-23.9-53.5-53.5zm157.9 267.1c-67.8 0-123.8-47.5-132.3-109h264.6c-8.6 61.5-64.5 109-132.3 109zm110-213.7c-29.5 0-53.5-23.9-53.5-53.5s23.9-53.5 53.5-53.5 53.5 23.9 53.5 53.5-23.9 53.5-53.5 53.5zM867.2 644.5V453.1h26.5c19.4 0 35.1 15.7 35.1 35.1v121.1c0 19.4-15.7 35.1-35.1 35.1h-26.5zM95.2 609.4V488.2c0-19.4 15.7-35.1 35.1-35.1h26.5v191.3h-26.5c-19.4 0-35.1-15.7-35.1-35.1zM561.5 149.6c0 23.4-15.6 43.3-36.9 49.7v44.9h-30v-44.9c-21.4-6.5-36.9-26.3-36.9-49.7 0-28.6 23.3-51.9 51.9-51.9s51.9 23.3 51.9 51.9z"
        ></path>
      </svg>
      <div class="message-text">
        Hey there 👋 <br />
        How can i help you today?
      </div>
    </div>
  )
}

function processResponse(responseMessage) {
  const text = responseMessage ?? "";
  const re = /\*\*(.*?)\*\*/;
  if (!re.test(text)) {
    return text;
  }
  const words = text.split(/\*\*/);
  console.log(words);
  return (
    <div>
      {words.map((part, i) =>
        i % 2 === 1 ? (
          <strong key={i}>{part}</strong>
        ) : (
          <span key={i}>{part}</span>
        )
      )}
    </div>
  );
}

export function BotMessageContent({ text, isThinking }) {
  return (
    <CreateMessageElement
      content={
        <>
          <svg className="bot-avatar" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 1024 1024">
            <path d="M738.3 287.6H285.7c-59 0-106.8 47.8-106.8 106.8v303.1c0 59 47.8 106.8 106.8 106.8h81.5v111.1c0 .7.8 1.1 1.4.7l166.9-110.6 41.8-.8h117.4l43.6-.4c59 0 106.8-47.8 106.8-106.8V394.5c0-59-47.8-106.9-106.8-106.9zM351.7 448.2c0-29.5 23.9-53.5 53.5-53.5s53.5 23.9 53.5 53.5-23.9 53.5-53.5 53.5-53.5-23.9-53.5-53.5zm157.9 267.1c-67.8 0-123.8-47.5-132.3-109h264.6c-8.6 61.5-64.5 109-132.3 109zm110-213.7c-29.5 0-53.5-23.9-53.5-53.5s23.9-53.5 53.5-53.5 53.5 23.9 53.5 53.5-23.9 53.5-53.5 53.5zM867.2 644.5V453.1h26.5c19.4 0 35.1 15.7 35.1 35.1v121.1c0 19.4-15.7 35.1-35.1 35.1h-26.5zM95.2 609.4V488.2c0-19.4 15.7-35.1 35.1-35.1h26.5v191.3h-26.5c-19.4 0-35.1-15.7-35.1-35.1zM561.5 149.6c0 23.4-15.6 43.3-36.9 49.7v44.9h-30v-44.9c-21.4-6.5-36.9-26.3-36.9-49.7 0-28.6 23.3-51.9 51.9-51.9s51.9 23.3 51.9 51.9z" />
          </svg>
          <div className="message-text" style={{ whiteSpace: "pre-wrap" }}>
            {isThinking ? (
              <div className="thinking-indicator">
                <div className="dot" />
                <div className="dot" />
                <div className="dot" />
              </div>
            ) : (
              processResponse(text)
              // text
            )}
          </div>
        </>
      }
      classes={["bot-message", isThinking ? "thinking" : ""]}
    />
  );
}

export function Chat({ chatHistory, containerRef }) {
  useLayoutEffect(() => {
    const el = containerRef?.current;
    if (!el) return;
    el.scrollTo({ top: el.scrollHeight, behavior: "smooth" });
  }, [chatHistory, containerRef]);

  return (
    <>
      {chatHistory.map((h) => (
        <>
          <React.Fragment key={h.id}>
            {h.role === "user" ? (
              <CreateMessageElement
                content={<MessageContent text={h.parts.find(p => typeof p.text === "string")?.text ?? ""} />}
                classes={["user-message"]}
              />
            ) : h.id === "Bot-initial-Message" ? (
              <BotInitialMessage />
            ) : (
              <BotMessageContent text={h.parts.find(p => typeof p.text === "string")?.text ?? ""} isThinking={!!h.thinking} />
            )}
          </React.Fragment>
        </>
      ))}
    </>
  );
}
